import React, {Component} from 'react';
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";

export default class TrasyTableSelectOdwrotna extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa:null
        };
        this.onChangeTrasa=this.onChangeTrasa.bind(this)
    }

    componentDidMount(){
        this.ustawTrase(this.props)
    }

    componentWillReceiveProps(nextprops){
        this.ustawTrase(nextprops)
    }

    ustawTrase(props){
        if(Boolean(props.idTrPow))
            this.setState({trasa: this.props.trasy.find(t=>t.idTr === props.idTrPow)})
    }

    onChangeTrasa(e){
        this.setState({trasa:e})
        this.props.handleChangeTrasaOdwrotna(e)
    }

    render() {

        return (
            <div>
                <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy} valueKey={'idTr'} labelKey={'nazTr'}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/components/TrasyTableSelectOdwrotna.js